import { z } from '@/utils/zod'

// Permissions
// ATTENTION: always add the i18n when add a new scope here
export const tenantPermissionScopes = [
    // -- general
    'tenant',
    'user',
    'application',
    'identity',
] as const

export const TenantPermissionScopeSchema = z.enum(tenantPermissionScopes)

export type TenantPermissionScope = z.infer<typeof TenantPermissionScopeSchema>

const TenantPermissionSchema = z.object({
    read: z.boolean(),
    insert: z.boolean(),
    edit: z.boolean(),
    remove: z.boolean(),
})

export type TenantPermission = z.infer<typeof TenantPermissionSchema>

export const TenantPermissionsSchema = z.partialRecord(TenantPermissionScopeSchema, TenantPermissionSchema)

export type TenantPermissions = z.infer<typeof TenantPermissionsSchema>

// Restrictions
export const tenantRestrictionScopes = ['application'] as const

export const TenantRestrictionScopeSchema = z.enum(tenantRestrictionScopes)

export type TenantRestrictionScope = z.infer<typeof TenantRestrictionScopeSchema>

export const TenantRestrictionsSchema = z.partialRecord(TenantRestrictionScopeSchema, z.array(z.objectId()))

export type TenantRestrictions = z.infer<typeof TenantRestrictionsSchema>

// Access
export const TenantAccessSchema = z.object({
    tenant: z.objectId(),
    owner: z.boolean(),
    permissions: TenantPermissionsSchema,
    restrictions: TenantRestrictionsSchema,
})

export type TenantAccess = z.infer<typeof TenantAccessSchema>

export const frozenTenantUserPermissions: Partial<Record<TenantPermissionScope, Partial<TenantPermission>>> = {
    tenant: {
        read: true,
    },
    user: {
        read: true,
    },
}

export const defaultTenantUserPermissions: TenantPermissions = {
    tenant: {
        read: true,
        insert: false,
        edit: false,
        remove: false,
    },
    user: {
        read: true,
        insert: false,
        edit: false,
        remove: false,
    },
    application: {
        read: true,
        insert: false,
        edit: false,
        remove: false,
    },
    identity: {
        read: true,
        insert: false,
        edit: false,
        remove: false,
    },
}

export const enabledTenantUserPermissions: TenantPermissionScope[] = [
    // -- general
    'tenant', // -> organisation
    'identity',
]

export const hiddenTenantUserScopes: Array<
    TenantPermissionScope | `${TenantPermissionScope}.${keyof TenantPermission}`
> = [
    'tenant.insert',
    'tenant.remove',
    // we removed this because it only affects old campai
    'user', // -> organisationUser
]
